const state = {
  loaded: false,
  loadError: null,
  currentTank: {},
  tanks: [],
  globalTanks: {},
  tanksObj: {},
  currentContainer: {},
  activeContainers: [],
  inactiveContainers: [],
  containerObjs: {},
  groups: [],
  consCategories: [],
  formulas: [],
  sensors: [],
  chemicals: [],
  chemSiteConfig: {},
  chemConfigTeamBySite: {}
};
const getters = {
  loadedSiteScan: state => state.loaded,
  siteScanLoadError: state => state.loadError,
  currentTank: state => state.currentTank,
  getTanks: state => state.tanks,
  getTanksObj: state => state.tanksObj,
  getGlobalTanks: state => state.globalTanks,
  getGlobalTanksBySensorRelationshipId: (state) => {
    let obj = {}
    for (let siteArr of Object.values(state.globalTanks)) {
      for (let tank of siteArr) {
        obj[tank.sensor_relationship?.id] = tank
      }
    }
    return obj
  },
  currentContainer: state => state.currentContainer,
  activeContainers: state => state.activeContainers,
  inactiveContainers: state => state.inactiveContainers,
  containerObjs: state => state.containerObjs,
  allContainers: state => [ ...state.activeContainers, ...state.inactiveContainers ],
  chemGroups: state => state.groups,
  consumableCategories: state => state.consCategories,
  chemFormulas: state => state.formulas,
  chemSensors: state => state.sensors,
  chemChemicals: state => state.chemicals,
  chemSiteConfig: state => state.chemSiteConfig,
  chemConfigTeamBySite: state => state.chemConfigTeamBySite
};
const mutations = {
  setSiteScanLoaded(state, loaded) {
    state.loaded = loaded
  },
  setSiteScanLoadError(state, error) {
    state.loadError = error
  },
  setCurrentContainer(state, newState) {
    state.currentContainer = newState
  },
  setActiveContainers(state, newState) {
    state.activeContainers = newState
    if (!newState) {
      state.containerObjs = {}
      return
    }
    for (let container of newState) {
      state.containerObjs[container.id] = container
    }
  },
  setInactiveContainers(state, newState) {
    state.inactiveContainers = newState
    if (!newState) {
      state.containerObjs = {}
      return
    }
    for (let container of newState) {
      state.containerObjs[container.id] = container
    }
  },
  setGlobalTanks(state, tanksArr) {
    let sites = {}
    for (let tank of tanksArr) {
      if (!sites[tank.site_id]) {
        sites[tank.site_id] = []
      }
      sites[tank.site_id].push(tank)
    }
    state.globalTanks = sites
  },
  setChemGroups(state, arr) {
    state.groups = arr
  },
  setConsumableCategories(state, arr) {
    state.consCategories = arr
  },
  setChemFormulas(state, arr) {
    state.formulas = arr
  },
  setChemSensors(state, arr) {
    state.sensors = arr
  },
  setChemicals(state, arr) {
    state.chemicals = arr
  },
  setChemSiteConfig(state, obj) {
    if (!obj) return
    state.chemSiteConfig = obj
    state.chemConfigTeamBySite[obj.site_id] = obj.config_data?.default_work_order_team
  },
  setChemTeamConfigBySite(state, [siteId, teamId]) {
    if (!siteId || !teamId) return
    state.chemConfigTeamBySite[siteId] = teamId
  }
};

export default {
  state,
  getters,
  mutations
};
